<template>
    <div class="collapsible" id="controle-etancheite" :class="stateClass">

        <div class="collapsible-head wrap" id="head-controle-etancheite"
             @click="$emit('openCollapsible','controle-etancheite')">
            CONTRÔLE D'ÉTANCHÉITÉ *
            <i class="icon-go"></i>
        </div>

        <div class="collapsible-body">

            <div class="head-etanch wrap">

                <a href="javascript: void 0" class="btn detecteur" @click="showDetec = true">
                    <i class="icon-look"></i>
                    <strong>MON DÉTECTEUR</strong>
                    MANUEL DE FUITES
                </a>

                <a href="javascript: void 0" class="btn add-fuite" @click.prevent="addFuite">
                    <strong>DÉCLARER</strong>
                    UNE FUITE
                    <i class="icon-add"></i>
                </a>

                <div class="clear"></div>

            </div>

            <div id="detecteur" class="modal detecteur" v-show="showDetec">
                <div>
                    <h1>Mon détecteur</h1>
                    <p>
                        <strong>{{ detecteur.marque }} - {{ detecteur.modele }} </strong><br>
                        <span v-if="detecteur.numero_serie">N°de série : <strong>{{ detecteur.numero_serie }}</strong><br></span>
                        Dernier contrôle : <strong>{{ detecteur.date_last_controle | dateFormat }}</strong>
                    </p>
                    <a href="javascript: void 0" class="btn close" @click="showDetec = false">FERMER</a>
                </div>
            </div>

            <div class="nofuite" v-show="showNoFuites">
                <input type="checkbox" id="nofuite" name="no_fuite" v-model="no_fuites" @change="$emit('isValidChanged', {isValid, no_fuites})">
                <label class="btn check" for="nofuite">
                    Aucune fuite à signaler
                    <i class="icon-valid"></i>
                </label>
            </div>

            <div class="list-fuites">

                <item-fuite
                        v-for="fuite in fuites"
                        :key="fuite.id"
                        :fuite="fuite"
                        @delFuite="removeFuite(fuite.id)"
                        @fuiteUpdated="updateFuite(fuite)">
                </item-fuite>

            </div>

        </div>
    </div>
</template>

<script>

    import Fuite from '../../../../js/models/Fuite'
    import ItemFuite from './ItemFuite.vue'

    export default {

        data() {
            return {
                showDetec: false,
                showNoFuites: true,
                fuites: [],
                no_fuites: null
            }
        },

        props: {
            open: null,
            nofuite: null,
            detecteur: {}
        },

        methods: {

            fetchFuites(){

                return new Promise((resolve, reject) => {

                    let idFiche = this.$route.params.id;

                    Fuite
                        .getListForFibsdd(idFiche)
                        .then(list => {
                            this.fuites = list.reverse();
                            resolve(true)
                        })
                        .catch(err => reject(err))

                })

            },

            addFuite() {

                if (this.fuites.length === 3) {

                    swal('3 Fuites max', 'Vous ne pouvez déclarer que 3 fuites au maximum', 'info')

                } else {
                    let previousShowNoFuites = this.showNoFuites;
                    let previousNoFuites = this.no_fuites;

                    this.no_fuites = false;
                    this.showNoFuites = false;

                    let id = 'F-';
                    let timestamp = '' + +new Date();
                    timestamp = timestamp.slice(7, 12);
                    id = id + timestamp;

                    let idFi = this.$route.params.id;
                    let ordre = this.fuites.length + 1;

                    if(!_.includes(idFi,'N-')){
                        idFi = parseInt(idFi)
                    }

                    let newFuite = {
                        id,
                        dossier: idFi,
                        ordre,
                        localisation: null,
                        etat: null,
                        reparation: null,
                        photo64: null
                    };

                    this.fuites.unshift(newFuite);

                    Fuite
                        .addFuiteOffline(newFuite)
                        .then(() => {
                            this.$emit('isValidChanged', {isValid: this.isValid, no_fuites: this.no_fuites})
                        })
                        .catch(() => {
                            let i = _.findIndex(this.fuites, ['id', newFuite.id]);
                            if (i !== -1) this.fuites.splice(i, 1);
                            this.showNoFuites = previousShowNoFuites;
                            this.no_fuites = previousNoFuites;
                            swal('Erreur', "La fuite n'a pas pu être enregistrée", 'error')
                        })

                }

            },

            removeFuite(id) {

                let indexToDel = _.findIndex(this.fuites, ['id', id]);

                if (indexToDel === -1) {
                    return
                }

                let previousShowNoFuites = this.showNoFuites;

                if (this.fuites.length === 1) {
                    this.showNoFuites = true
                }

                let removedFuite = this.fuites[indexToDel];

                this.fuites.splice(indexToDel, 1);

                let previousOrdres = this.fuites.map(f => ({id: f.id, ordre: f.ordre}));

                if(this.fuites.length !== 0){
                    let length = this.fuites.length;
                    for(let f in this.fuites){
                        this.fuites[f].ordre =  length;
                        length--
                    }

                }

                Fuite
                    .removeFuiteOffline(id)
                    .then(() => {
                        for(let f in this.fuites){
                            this.updateFuite(this.fuites[f])
                        }

                        this.$emit('isValidChanged', {isValid: this.isValid, no_fuites: this.no_fuites})

                    })
                    .catch(() => {
                        _.each(previousOrdres, po => {
                            let f = _.find(this.fuites, ['id', po.id]);
                            if (f) f.ordre = po.ordre;
                        });

                        this.fuites.splice(indexToDel, 0, removedFuite);
                        this.showNoFuites = previousShowNoFuites;
                        swal('Erreur', "La fuite n'a pas pu être supprimée", 'error')
                    })

            },

            updateFuite(f) {

                Fuite
                    .updateFuiteOffline(f)
                    .then(() => {
                        this.$emit('isValidChanged', {isValid: this.isValid, no_fuites: this.no_fuites})
                    })
                    .catch(() => {
                        swal('Erreur', "La modification n'a pas pu être enregistrée", 'error')
                    })

            },

        },

        computed: {

            stateClass() {
                if (this.open === 'controle-etancheite') {
                    return 'open'
                } else {
                    return ''
                }
            },

            isValid() {

                if (this.fuites.length > 0){
                    let err = true;

                    _.each(this.fuites, f => {
                        if( (f.localisation === null || f.localisation === '') || f.reparation === null){
                            err = false
                        }
                    });

                    return err

                }  else {

                    return this.no_fuites

                }

            }

        },

        mounted() {
            this.no_fuites = this.nofuite;

            this
                .fetchFuites()
                .then(() => {
                    if (this.fuites.length > 0) {
                        this.showNoFuites = false
                    }

                    // JE SAIS PLUS POURQUOI Y AVAIT ÇA AVANT
                    // MAIS ÇA CREE UNE OPÉRATION HORS LIGNE DÈS QU'ON ARRIVE SUR LA PAGE DONC PAS TERRIBLE
                    this.$emit('isValidChanged', {isValid: this.isValid, no_fuites: this.no_fuites})

                })
                .catch()

        },

        components: {

            ItemFuite

        }

    }

</script>

<style>
    #controle-etancheite .collapsible-body div.modal {
        position: fixed;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background-color: rgba(55, 55, 54, 0.9);
        z-index: 99;
    }

    #controle-etancheite .collapsible-body div.modal.open {
        display: block;
    }

    #controle-etancheite .collapsible-body div.modal > div {
        background-color: white;
        width: calc(100% - 20px);
        max-width: 350px;
        min-height: 260px;
        margin: auto;
        display: block;
        padding-top: 35px;
        padding-bottom: 20px;
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        text-align: center;
        border-radius: 5px;
    }

    #controle-etancheite .collapsible-body div.modal > div h1 {
        font-size: 2.5rem;
        font-weight: 700;
        text-transform: uppercase;
        margin-bottom: 30px;
    }

    #controle-etancheite .collapsible-body div.modal > div a {
        width: 90px;
        margin: auto;
        margin-top: 20px;
        text-align: center;
        background-color: #5698d2;
        color: white;
        padding-left: 20px;
    }

    #controle-etancheite .collapsible-body > .head-etanch.wrap a.btn {
        float: left;
        margin-bottom: 15px;
    }

    #controle-etancheite .collapsible-body > .head-etanch.wrap a.btn.detecteur {
        padding-left: 45px;
        width: calc(50%);
        margin-right: 10px;
        background-color: #999;
        color: white;
    }

    #controle-etancheite .collapsible-body > .head-etanch.wrap a.btn.detecteur i {
        position: absolute;
        left: 10px;
        top: 15px;
        font-size: 2.0rem;
    }

    #controle-etancheite .collapsible-body > .head-etanch.wrap a.btn.add-fuite {
        width: 40%;
        color: white;
        background-color: #5698d2;
        padding-left: 20px;
    }

    #controle-etancheite .collapsible-body .fuite {
        min-height: 190px;
        background-color: #eee;
        width: 100%;
        margin-bottom: 15px;
        padding: 10px;
    }

    #controle-etancheite .collapsible-body .fuite .head-fuite a {
        float: right;
        margin-left: 10px;
        margin-bottom: 10px;
    }

    #controle-etancheite .collapsible-body .fuite img,
    #controle-etancheite .collapsible-body .fuite canvas {
        max-width: 100%;
        max-height: 150px;
        margin-bottom: 10px;
    }

    #controle-etancheite .collapsible-body .fuite strong {
        text-transform: uppercase;
        font-weight: 400;
        color: #000000;
        font-size: 2.0rem;
    }

    #controle-etancheite .collapsible-body .fuite .btn.del {
        width: 50px;
        height: 40px;
        background-color:  #c31616;
    }

    #controle-etancheite .collapsible-body .fuite .btn.del i {
        font-size: 2.7rem;
        color: #ffffff;
        margin-left: 7px;
    }

    #controle-etancheite .collapsible-body .fuite .btn.photo {
        width: 100px;
        height: 40px;
        padding-left: 40px;
        color: #fff;
        font-weight: 700;
        background-color: #5698d2;
    }

    #controle-etancheite .collapsible-body .fuite .btn.photo i {
        color: #2b4c69;
        font-size: 2.5rem;
        position: absolute;
        top: 8px;
        left: 5px;
    }

    #controle-etancheite .collapsible-body .fuite .checkfuite > *:not(.clear) {
        position: relative;
        width: 33%;
        float: left;
        display: block;
    }

    #controle-etancheite .collapsible-body .fuite .checkfuite > *:not(.clear) input:checked + .btn {
        background-color: #86bc24;
        color: white;
        font-weight: 700;
    }

    #controle-etancheite .collapsible-body .fuite .checkfuite > *:not(.clear) input:checked + .btn i {
        color: #fff;
    }

    #controle-etancheite .collapsible-body .fuite .checkfuite > *:not(.clear).check {
        width: 30%;
    }

    #controle-etancheite .collapsible-body .fuite .checkfuite > *:not(.clear).check:last-child {
        margin-left: 3%;
    }

    #controle-etancheite .collapsible-body .fuite .checkfuite > *:not(.clear) label.btn {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: auto;
        min-height: 50px;
        background-color: #e2e2e2;
        color: #999;
        font-size: 1.5rem;
        font-weight: 400;
        padding-left: 10px;
        padding-right: 30px;
        line-height: 1.2;
    }

    #controle-etancheite .collapsible-body .fuite .checkfuite > *:not(.clear) label.btn i {
        position: absolute;
        right: 7px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        color: #999;
        font-size: 2.3rem;
    }

    #controle-etancheite .collapsible-body .fuite .img-content li {
        position: relative;
    }

    #controle-etancheite .collapsible-body .fuite .img-content li a.icon-delete {
        display: block;
        position: absolute;
        left: 5px;
        top: 5px;
        height: 30px;
        width: 30px;
        background-color: #c31616;
        text-align: center;
        line-height: 28px;
        color: white;
        border-radius: 5px;
        font-size: 2.0rem;
    }

    #controle-etancheite .collapsible-body div.nofuite input {
        display: none;
    }

    #controle-etancheite .collapsible-body div.nofuite label.btn.check {
        position: relative;
        background-color: #e2e2e2;
        color: #999;
        padding-left: 20px;
        font-size: 1.5rem;
        font-weight: 400;
        text-transform: none;
        margin-bottom: 15px;
    }

    #controle-etancheite .collapsible-body div.nofuite label.btn.check i {
        position: absolute;
        top: 10px;
        font-size: 2.3rem;
        right: 15px;
        color: #999;
    }

    #controle-etancheite .collapsible-body div.nofuite input:checked + label.btn.check {
        background-color: #86bc24;
        color: #fff;
    }

    #controle-etancheite .collapsible-body div.nofuite input:checked + label.btn.check i {
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// ControlEtanch.vue?441c6e50